import {
  AdvancedFilterCategories,
  DEVELOPMENT_STATUSES_CHECK_LIST,
  HYDROCARBONS_CHECK_LIST,
  SHORE_STATUSES_CHECK_LIST,
} from '../../../../components/Filters/filterTypes';
import { FilterBarWrapper, FilterSetsProvider } from '../../../../components/FilterBarWrapper';
import { MA_OPPORTUNITIES_CONTEXT, useMaOpportunitiesContext } from '../../MaOpportunitiesContext';
import React, { useState } from 'react';

import { AdvancedFiltersRow } from '../../../../components/Filters/advancedFilters';
import { FILTER_TYPES } from './constants';
import { FilterList } from '@mui/icons-material';
import { GOOGLE_ANALYTICS_TAG } from './constants';
import { HYDROCARBON_TYPES } from '../../../../utils/constants';
import { PageActions } from '../../../../components/PageActions';
import { useGetDevelopmentStatuses } from './hooks/useGetDevelopmentStatuses';
import { useGetFiltersSummary } from './hooks/useGetFiltersSummary';
import { useGetShoreStatuses } from '../../../../hooks/useGetShoreStatuses';
import { useGetSliderFilterTypes } from './hooks/useGetSliderFilterTypes';
import { useStyles } from './styles';
import { useUpdateFilterRanges } from './hooks/useUpdateFilterRanges';

export const Filters = () => {
  const [openAdvancedFilters, setOpenAdvancedFilters] = useState(false);
  const classes = useStyles();
  const { loading, filters, setFilters, resetFilters } = useMaOpportunitiesContext();
  const { loading: loadingSummary } = useGetFiltersSummary();
  const { sliderFilters, sliderMaxValues } = useGetSliderFilterTypes();
  const { shoreStatuses } = useGetShoreStatuses();
  const { developmentStatuses } = useGetDevelopmentStatuses();

  useUpdateFilterRanges();

  const toggleAdvancedFilters = () => setOpenAdvancedFilters((prev) => !prev);

  return (
    <FilterSetsProvider filterSetsCount={1}>
      <FilterBarWrapper
        filters={filters}
        growFirstFilter
        applyFilters={setFilters}
        context={MA_OPPORTUNITIES_CONTEXT}
        googleAnalyticsTag={GOOGLE_ANALYTICS_TAG}
        basicFilterTypes={FILTER_TYPES}
        filterItemClass={classes.filterItem}
        advancedFiltersOpened={openAdvancedFilters}
        advancedFilters={
          <AdvancedFiltersRow
            loading={loading || loadingSummary}
            context={MA_OPPORTUNITIES_CONTEXT}
            filters={filters}
            setFilters={setFilters}
            googleAnalyticsTag={GOOGLE_ANALYTICS_TAG}
            minMaxFilterTypes={[]}
            sliderFiltersLabel="Asset/Block Values"
            sliderFilterTypes={sliderFilters}
            sliderFilterMaxValues={sliderMaxValues}
            checkListAllReturnsNone
            checkListFilterTypes={[
              HYDROCARBONS_CHECK_LIST,
              DEVELOPMENT_STATUSES_CHECK_LIST,
              SHORE_STATUSES_CHECK_LIST,
            ]}
            checkListItems={{
              shoreStatuses,
              developmentStatuses,
              hydrocarbons: HYDROCARBON_TYPES,
            }}
            order={[AdvancedFilterCategories.checkLists, AdvancedFilterCategories.sliders]}
            equalWidth
          />
        }
      >
        <PageActions
          onOpenFilters={toggleAdvancedFilters}
          openFiltersLabel={openAdvancedFilters ? 'Less Filters' : 'All Filters'}
          openFiltersDisabled={loading || loadingSummary}
          openFiltersStartIcon={<FilterList />}
          onClearFilters={resetFilters}
        />
      </FilterBarWrapper>
    </FilterSetsProvider>
  );
};
